// Lib
import { fork } from 'redux-saga/effects';

// Sagas
import accountSaga from './accountSaga';
import feedSaga from './feedSaga';
import dataSaga from './dataSaga';
import paymentsSaga from './paymentsSaga';
import settingsSaga from '@modules/Settings/sagas';
import profileSaga from '@modules/Profile/sagas';
import postSaga from '@modules/Post/sagas';
import productsSaga from './productsSaga';

function* mainSaga(): Generator<unknown, void, unknown> {
  yield fork(dataSaga);
  yield fork(accountSaga);
  yield fork(feedSaga);
  yield fork(settingsSaga);
  yield fork(profileSaga);
  yield fork(postSaga);
  yield fork(paymentsSaga);
  yield fork(productsSaga);
}

export default mainSaga;
